import { useDispatch } from 'react-redux';
import { toogleErrorToast } from 'reducers/misc';

export function useErrorToast(message: string) {
  const dispatch = useDispatch();
  const windowGlobal = typeof window !== 'undefined';

  return () => {
    dispatch(toogleErrorToast({ open: true, message: message }));

    windowGlobal &&
      window.setTimeout(() => {
        dispatch(toogleErrorToast({ open: true, message: '' }));
      }, 3500);

    windowGlobal &&
      window.setTimeout(() => {
        dispatch(toogleErrorToast({ open: false, message: '' }));
      }, 3600);
  };
}
